import { __assign } from "tslib";
export default (function (_a) {
    var children = _a.children, props = _a.props, theme = _a.theme;
    var appearance = typeof props === 'object' ? 'default' : props;
    var merged = typeof props === 'object' ? __assign({}, props) : {};
    Object.keys(theme).forEach(function (key) {
        if (!(key in merged)) {
            merged[key] = theme[key]({ appearance: appearance });
        }
    });
    return children(merged);
});
//# sourceMappingURL=Appearance.js.map